
import React, { useState, useEffect, useRef } from "react";
import "./AIAgent.scss";

const SplitLayout = ({ left, right, isOpen, initialWidth = 400 }) => {
  const [width, setWidth] = useState(initialWidth);
  const [isResizing, setIsResizing] = useState(false);
  const resizerRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizing) return;
      // Calculate new width: Total Window Width - Mouse X
      // (Since panel is on the right)
      const newWidth = window.innerWidth - e.clientX;
      if (newWidth > 300 && newWidth < 800) {
        setWidth(newWidth);
      }
    };

    const handleMouseUp = () => {
      setIsResizing(false);
      document.body.style.cursor = "default";
      document.body.style.userSelect = "auto";
    };

    if (isResizing) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
    }

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isResizing]);

  const startResizing = (e) => {
    setIsResizing(true);
    e.preventDefault();
  };

  return (
    <div className="split-layout-container">
      <div className="left-pane">
        {left}
        {isResizing && <div className="iframe-overlay" />}
      </div>
      
      {isOpen && (
        <>
          <div 
            className="resizer" 
            onMouseDown={startResizing}
            ref={resizerRef}
          />
          <div 
            className="right-pane"
            style={{ width: width }}
          >
            {right}
          </div>
        </>
      )}
    </div>
  );
};

export default SplitLayout;
